import React from 'react';
import mapboxgl from 'mapbox-gl';
import { applyMapboxToken } from '../utils/mapboxToken';
import CoordinateToolTabs from '../components/coordinateTool/CoordinateToolTabs';
import SystemFormatSelectors from '../components/coordinateTool/SystemFormatSelectors';
import SingleConvertPanel from '../components/coordinateTool/SingleConvertPanel';
import BatchConvertPanel from '../components/coordinateTool/BatchConvertPanel';
import MapUrlParsePanel from '../components/coordinateTool/MapUrlParsePanel';
import FileProcessPanel from '../components/coordinateTool/FileProcessPanel';
import CoordinateToolMapPane from '../components/coordinateTool/CoordinateToolMapPane';
import CoordinateToolHistoryPanel from '../components/coordinateTool/CoordinateToolHistoryPanel';
import useCoordinateToolForm from '../hooks/useCoordinateToolForm';
import useCoordinateToolParse from '../hooks/useCoordinateToolParse';
import useCoordinateToolHistory from '../hooks/useCoordinateToolHistory';
import useCoordinateToolMap from '../hooks/useCoordinateToolMap';

applyMapboxToken(mapboxgl);

/**
 * 坐标转换工具页（薄壳：组合 hooks + 面板）
 */
function CoordinateTool() {
  const form = useCoordinateToolForm();
  const history = useCoordinateToolHistory();
  const map = useCoordinateToolMap({
    result: form.result,
    mapUrlResult: form.mapUrlResult,
    activeTab: form.activeTab,
    setMapCenter: form.setMapCenter,
    mapMarker: form.mapMarker,
    setMapMarker: form.setMapMarker
  });
  const parse = useCoordinateToolParse({
    inputLat: form.inputLat,
    inputLng: form.inputLng,
    setInputLat: form.setInputLat,
    setInputLng: form.setInputLng,
    mapUrl: form.mapUrl,
    setMapUrl: form.setMapUrl,
    setMapUrlResult: form.setMapUrlResult,
    setLoading: form.setLoading
  });

  const isMobile = window.innerWidth <= 900;

  return (
    <div style={{ padding: 20 }}>
      <h2 style={{ marginBottom: 20, color: '#1976d2' }}>坐标转换工具</h2>

      <CoordinateToolTabs activeTab={form.activeTab} setActiveTab={form.setActiveTab} />

      <div style={{ display: 'flex', flexDirection: isMobile ? 'column' : 'row', minHeight: '60vh', width: '100%', gap: isMobile ? 12 : 16 }}>
        <div style={{
          flex: isMobile ? '1 1 auto' : '1 1 300px',
          maxWidth: isMobile ? '100%' : 360,
          padding: isMobile ? '8px 2px' : '24px 8px 24px 0',
          fontSize: isMobile ? 13 : 16
        }}>
          {(form.activeTab === 'single' || form.activeTab === 'batch') && (
            <SystemFormatSelectors
              fromSystem={form.fromSystem}
              setFromSystem={form.setFromSystem}
              toSystem={form.toSystem}
              setToSystem={form.setToSystem}
              outputFormat={form.outputFormat}
              setOutputFormat={form.setOutputFormat}
              coordinateSystems={form.coordinateSystems}
              outputFormats={form.outputFormats}
            />
          )}

          {form.activeTab === 'single' && (
            <SingleConvertPanel
              inputLat={form.inputLat}
              setInputLat={form.setInputLat}
              inputLng={form.inputLng}
              setInputLng={form.setInputLng}
              handleCoordinatePaste={parse.handleCoordinatePaste}
              handleConvert={form.handleConvert}
              handleCoordinateParse={parse.handleCoordinateParse}
              loading={form.loading}
              result={form.result}
              handleExport={form.handleExport}
            />
          )}

          {form.activeTab === 'batch' && (
            <BatchConvertPanel
              batchInput={form.batchInput}
              setBatchInput={form.setBatchInput}
              handleBatchConvert={form.handleBatchConvert}
              loading={form.loading}
              batchResult={form.batchResult}
              handleExport={form.handleExport}
            />
          )}

          {form.activeTab === 'mapurl' && (
            <MapUrlParsePanel
              mapUrl={form.mapUrl}
              setMapUrl={form.setMapUrl}
              handleMapUrlParse={parse.handleMapUrlParse}
              loading={form.loading}
              mapUrlResult={form.mapUrlResult}
            />
          )}

          {form.activeTab === 'file' && (
            <FileProcessPanel
              handleFileChange={form.handleFileChange}
              handleFileUpload={form.handleFileUpload}
              loading={form.loading}
              file={form.file}
              fileResult={form.fileResult}
              handleExport={form.handleExport}
            />
          )}
        </div>

        <CoordinateToolMapPane
          isMobile={isMobile}
          isFullScreen={map.isFullScreen}
          mapType={map.mapType}
          setMapType={map.setMapType}
          mapCenter={form.mapCenter}
          mapMarker={form.mapMarker}
          setMapCenter={form.setMapCenter}
          setMapMarker={form.setMapMarker}
          handleFullScreen={map.handleFullScreen}
        />

        <CoordinateToolHistoryPanel
          isMobile={isMobile}
          isFullScreen={map.isFullScreen}
          canViewAllHistory={history.canViewAllHistory}
          selectedUserId={history.selectedUserId}
          setSelectedUserId={history.setSelectedUserId}
          fetchHistory={history.fetchHistory}
          users={history.users}
          history={history.history}
        />
      </div>
    </div>
  );
}

export default CoordinateTool;
